/**
 * 业务主题
 */
import type { Theme } from '../../core/theme';
import { businessTreemapMarketLightParse } from './treemapMarketLight';

export const businessTreemapMarketLight = {
  name: 'business-treemap-market-light' as const,
  parsers: [businessTreemapMarketLightParse]
} as Theme;
